import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useServiceWorkerUpdate = () => {
  const location = useLocation();

  // effect added from router location to check for a new service worker on every page transition (change of route).
  useEffect(() => {
    // console.log('location change');
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready
        .then((registration) => {
          // console.log('registration.update();');
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          registration.update();
        })
        .catch(() => console.log('error in serviceWorker update'));
    }
  }, [location]);
};
